module.exports = __webpack_public_path__ + "static/img/arrow-point-to-left.9f4aa90d.svg";